<template>
  <div class="step">
    <div class="step__headline">
      <h3 class="step__title">Выберите параметры</h3>
      <div class="step__pagecounter">Шаг 2 из 3</div>
    </div>
    <h4 class="step__title">Покупатель</h4>
    <div class="step__split">
      <TextInput v-model="form.buyer.name" text="Фамилия Имя" name="name"/>
      <DateInput v-model="form.buyer.birthdate" text="Дата рождения" name="birthdate" ref="birthdate"/>
    </div>
    <div class="step__split">
      <NumberInput text='Номер телефона'
                name='tel'
                type='tel'
                ref="tel"
                :filled="(v)=>v.length==18"
                mask='+7 (###) ###-##-##'
                v-model="form.buyer.tel" />
      <EmailInput text="Электронная почта"
                name='email'
                ref="email"
                v-model="form.buyer.email" />      
    </div>
    <h4 class="step__title mb0">Укажите участников поездки</h4>
    <p style="margin-top: 8px">Введите фамилию и имя латиницей, как указано в загранпаспорте</p>
    <div class="step__split" v-for="(v,i) in form.persons" :key="i">
      <TextInput v-model="v.name" text="Фамилия Имя" :name="`person${i}name`" ref="pnames"/>
      <DateInput v-model="v.birthdate" text="Дата рождения" :name="`person${i}birthdate`" ref="pbirthdates"/>
    </div>
    <AddPerson @click="this.$store.state.form.persons.push({name: '', birthdate: ''}); $store.dispatch('updateAddonsPrice')"/>
    <CheckBox name="policyholder-is-insured" v-model="form.policyholder_is_insured" @update:modelValue="$store.dispatch('updateAddonsPrice')">Страхователь является застрахованным</CheckBox>
    <div class="step__divideline step__divideline_big calc-disappearing"></div>
    <div class="step__buttonwrap">
      <Btn class="step__button" :disabled="!ok" @click="toNextStep">Далее</Btn>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Btn from './Btn.vue'
import CheckBox from './inputs/CheckBox.vue';
import DateInput from './inputs/DateInput.vue';
import TextInput from './inputs/TextInput.vue';
import AddPerson from './AddPerson.vue'
import NumberInput from './inputs/NumberInput.vue';
import EmailInput from './inputs/EmailInput.vue';
export default {
  components: { AddPerson, CheckBox, Btn, DateInput, TextInput, NumberInput, EmailInput },
  data: () => ({
    actions: {}
  }),
  computed: {
    ...mapState(['form']),
    ok(){
      let f = this.form
      if (!f.buyer.name) return false
      if (!f.buyer.birthdate || this.$refs.birthdate?.$data?.error) return false
      if (!f.buyer.tel || this.$refs.tel?.$data?.error) return false
      if (!f.buyer.email || this.$refs.email?.$data?.error) return false
      for (let i = 0; i < f.persons.length; i++) {
        if (!f.persons[i].name || !f.persons[i].birthdate) return false
        if (this.$refs.pbirthdates[i].$data?.error) return false
      }
      // if(!f.policyholder_is_insured) return false
      return true
    }
  },
  methods: {
    toNextStep() {
      if (!this.actions.step2) {
        this.actions.step2 = true
        this.$store.dispatch('callAction', 'step2')
      }
      this.$store.dispatch('nextStep')
    }
  },
  watch: {
    /* TODO
    'form.tariff':function(v){
      if (v && !this.actions.tariff) {
        this.actions.tariff = true
        this.$store.dispatch('callAction','tariff')
      }
    }
    */
  }
}
</script>

<style lang="sass">

</style>